export default "__VITE_ASSET__8f4b7222__"